import React from "react";
import Cards from "../../components/client/Cards";
import { Link } from "react-router-dom";
const ClientDashboard = () => {
  const cardsData = [
    {
      id: 1211,
      title: "Estimates",
      num: 1,
      actions: [
        {
          id: 1003,
          actionTitle: "Awaiting Response",
          actionNum: 1,
        },
        {
          id: 9090,
          actionTitle: "Approved",
          actionNum: 1,
        },
        {
          id: 8080,
          actionTitle: "Changes requested",
          actionNum: 0,
        },
        {
          id: 1209,
          actionTitle: "Declined Response",
          actionNum: 1,
        },
      ],
      desc: "Keep track of estimates using customer portal module",
      allLink: "/client/estimates",
      image:"/icons/estimates.png"
    },
    {
      id: 1221,
      title: "Tickets",
      num: 1,
      actions: [
        {
          id: 1004,
          actionTitle: "Open",
          actionNum: 1,
        },
        {
          id: 9091,
          actionTitle: "Closed",
          actionNum: 1,
        },
        {
          id: 8081,
          actionTitle: "Cancelled",
          actionNum: 0,
        },
      ],
      desc: "Keep track of all repair tickets and stay updated on activities without navigating",
      allLink: "/client/tickets",
      createLink: "/",
      image:"/icons/ticket.png"
    },
    {
      id: 1222,
      title: "Invoices",
      num: 2,
      actions: [
        {
          id: 1005,
          actionTitle: "Paid",
          actionNum: 1,
        },
        {
          id: 9095,
          actionTitle: "Unpaid",
          actionNum: 1,
        },
        {
          id: 8085,
          actionTitle: "Partial",
          actionNum: 0,
        },
      ],
      desc: "Keep track of all repair tickets and stay updated on activities without navigating",
      allLink: "/client/invoices",
      image:"/icons/invoice.png"
    },
  ];
  return (
    <div className="container">
      <div className="row d-flex justify-content-center align-items-center mt-5">
        <div className="d-flex justify-content-between align-items-center">
        <h2>Dashboard</h2>
        <Link to="/client/create-lead" className="btn bg-black text-white">
          + Create Lead
          </Link>
        </div>
        {cardsData.map((item) => {
          return (
            <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 d-flex justify-content-center g-3">
              <Cards CardData={item} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ClientDashboard;
